import Login from "./Login"

const AuthFlowContainer = () => {
  return <Login />
}

export default AuthFlowContainer
